import { render, staticRenderFns } from "./addCommonToFolder.vue?vue&type=template&id=5ec63be8&scoped=true&"
import script from "./addCommonToFolder.vue?vue&type=script&lang=js&"
export * from "./addCommonToFolder.vue?vue&type=script&lang=js&"
import style0 from "./addCommonToFolder.vue?vue&type=style&index=0&id=5ec63be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec63be8",
  null
  
)

export default component.exports